import React from 'react';
import { safeHTML } from './sanitize-html';

export function renderHTML(contentProvided) {
  const sanitizedContent = safeHTML(contentProvided);
  // eslint-disable-next-line react/no-danger -- needed
  return (<div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />);
}
